export default __webpack_public_path__ + "static/media/Witbooker_EN.aba60cf7.png";